import React from 'react';
import { Calculator, DollarSign, Users, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

const cards = [
  {
    title: 'Instant HVAC Estimate',
    description: 'Get an instant estimate for replacing your HVAC system based on your home and system type.',
    href: '/instant-hvac-estimate-new-orleans',
    icon: Calculator,
    iconBg: 'bg-orange-50',
    iconColor: 'text-[#F97316]',
  },
  {
    title: 'HVAC Replacement Cost Guide',
    description: 'Learn what HVAC systems typically cost in the New Orleans area.',
    href: '/ac-replacement-cost-new-orleans',
    icon: DollarSign,
    iconBg: 'bg-sky-50',
    iconColor: 'text-[#0EA5E9]',
  },
  {
    title: 'Compare Local HVAC Contractors',
    description: 'Explore trusted HVAC companies serving your area.',
    href: '/compare-hvac-contractors',
    icon: Users,
    iconBg: 'bg-slate-100',
    iconColor: 'text-[#0F172A]',
  },
];

const LocalHVACResource = () => {
  return (
    <section className="py-16 bg-white" data-testid="local-hvac-resource-section">
      <div className="max-w-6xl mx-auto px-6">
        <h2
          className="text-3xl md:text-4xl font-bold text-center text-[#0F172A] mb-3"
          style={{ fontFamily: 'Outfit, sans-serif' }}
        >
          Louisiana's Local HVAC Resource
        </h2>
        <p className="text-center text-slate-500 mb-12 max-w-2xl mx-auto">
          Everything you need to make an informed HVAC decision — from instant pricing to trusted local pros.
        </p>

        <div className="grid md:grid-cols-3 gap-6">
          {cards.map((card) => (
            <div
              key={card.title}
              className="bg-slate-50 rounded-2xl p-6 flex flex-col"
              data-testid={`local-resource-card-${card.title.toLowerCase().replace(/\s/g, '-')}`}
            >
              <div className={`w-12 h-12 ${card.iconBg} rounded-xl flex items-center justify-center mb-4`}>
                <card.icon className={`w-6 h-6 ${card.iconColor}`} />
              </div>
              <h3
                className="text-lg font-bold text-[#0F172A] mb-2"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                {card.title}
              </h3>
              <p className="text-slate-500 text-sm mb-6 flex-1">{card.description}</p>
              <a href={card.href}>
                <Button
                  variant="outline"
                  className="w-full border-[#0EA5E9] text-[#0EA5E9] hover:bg-[#0EA5E9] hover:text-white font-semibold rounded-full"
                  data-testid={`local-resource-btn-${card.title.toLowerCase().replace(/\s/g, '-')}`}
                >
                  Learn More
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocalHVACResource;
